var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a, _b;
import React from "react";
import styled from "styled-components";
import { mobile, tablet } from "../../utils/breakpoints";
import { createElement } from "react";
import { fonts } from "../../fonts";
export var HeadingSize;
(function (HeadingSize) {
    HeadingSize[HeadingSize["H1Large"] = 0] = "H1Large";
    HeadingSize[HeadingSize["H1"] = 1] = "H1";
    HeadingSize[HeadingSize["H2"] = 2] = "H2";
    HeadingSize[HeadingSize["H3"] = 3] = "H3";
    HeadingSize[HeadingSize["H4"] = 4] = "H4";
    HeadingSize[HeadingSize["H5"] = 5] = "H5";
})(HeadingSize || (HeadingSize = {}));
var headerStyles = (_a = {},
    _a[HeadingSize.H1Large] = {
        fontSize: ["5.5rem", "4rem", "3rem"],
        lineheight: "0.91",
    },
    _a[HeadingSize.H1] = {
        fontSize: ["3.5rem", "3rem", "2.5rem"],
        lineheight: "1.14",
    },
    _a[HeadingSize.H2] = {
        fontSize: ["3rem", "3rem", "2.5rem"],
        lineheight: "1.17",
    },
    _a[HeadingSize.H3] = {
        fontSize: ["2.5rem", "2.5rem", "2rem"],
    },
    _a[HeadingSize.H4] = {
        fontSize: "2rem",
    },
    _a[HeadingSize.H5] = {
        fontSize: "1.5rem",
    },
    _a);
var japaneseStyles = (_b = {},
    _b[HeadingSize.H1Large] = {
        fontSize: ["3.5rem", "3rem", "2rem"],
    },
    _b[HeadingSize.H1] = {
        fontSize: ["2.25rem", "2rem", "1.75rem"],
    },
    _b[HeadingSize.H2] = {
        fontSize: ["2rem", "2rem", "1.75rem"],
    },
    _b[HeadingSize.H3] = {
        fontSize: ["1.75rem", "1.75rem", "1.5rem"],
    },
    _b[HeadingSize.H4] = {
        fontSize: "1.5rem",
    },
    _b[HeadingSize.H5] = {
        fontSize: "1.25rem",
    },
    _b);
export var Heading = styled(function (_a) {
    var tag = _a.tag, children = _a.children, p = __rest(_a, ["tag", "children"]);
    return createElement(tag, p, children);
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  letter-spacing: 0rem;\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  color: ", ";\n  line-height: ", ";\n\n  ", " {\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n\n  ", " {\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n\n  :lang(ja-JP) {\n    ", "\n\n    ", " {\n      ", "\n    }\n\n    ", " {\n      ", "\n    }\n  }\n"], ["\n  margin: 0;\n  letter-spacing: 0rem;\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  color: ", ";\n  line-height: ", ";\n\n  ", " {\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n\n  ", " {\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n\n  :lang(ja-JP) {\n    ", "\n\n    ", " {\n      ", "\n    }\n\n    ", " {\n      ", "\n    }\n  }\n"])), function (p) { return getStyle("padding-top", p.pt, Breakpoints.all, "0"); }, function (p) { return getStyle("padding-bottom", p.pb, Breakpoints.all, "0"); }, function (p) { return getStyle("text-align", p.align, Breakpoints.all, "left"); }, function (p) { return getStyle("font-size", p.fontSize, Breakpoints.all, "3.5rem"); }, function (p) { return getStyle("font-family", p.fontFamily, Breakpoints.all, fonts.heading); }, function (p) { return getStyle("font-weight", p.fontWeight); }, function (p) { return p.color || p.theme.headerColour; }, function (p) { return p.lineheight || "1.14"; }, tablet, function (p) { return getStyle("padding-top", p.pt, Breakpoints.tablet); }, function (p) { return getStyle("padding-bottom", p.pb, Breakpoints.tablet); }, function (p) { return getStyle("text-align", p.align, Breakpoints.tablet); }, function (p) { return getStyle("font-size", p.fontSize, Breakpoints.tablet, "3rem"); }, mobile, function (p) { return getStyle("padding-top", p.pt, Breakpoints.mobile); }, function (p) { return getStyle("padding-bottom", p.pb, Breakpoints.mobile); }, function (p) { return getStyle("text-align", p.align, Breakpoints.mobile); }, function (p) { return getStyle("font-size", p.fontSize, Breakpoints.mobile, "2.5rem"); }, function (p) { var _a; return getStyle("font-size", (_a = japaneseStyles[p.size]) === null || _a === void 0 ? void 0 : _a.fontSize, Breakpoints.all, "3.5rem"); }, tablet, function (p) { var _a; return getStyle("font-size", (_a = japaneseStyles[p.size]) === null || _a === void 0 ? void 0 : _a.fontSize, Breakpoints.tablet, "3rem"); }, mobile, function (p) { var _a; return getStyle("font-size", (_a = japaneseStyles[p.size]) === null || _a === void 0 ? void 0 : _a.fontSize, Breakpoints.mobile, "2.5rem"); });
Heading.defaultProps = {
    tag: "h1",
};
export var getHeader = function (_a, children, tag) {
    var _b = _a.size, size = _b === void 0 ? HeadingSize.H1 : _b, style = _a.style, className = _a.className, id = _a.id, pt = _a.pt, pb = _a.pb, align = _a.align, fontSize = _a.fontSize, color = _a.color, lineheight = _a.lineheight, fontFamily = _a.fontFamily, fontWeight = _a.fontWeight;
    var headerStyle = headerStyles[size] || {};
    return (React.createElement(Heading, { tag: tag, style: style, className: className, id: id, pt: pt || headerStyle.pt, pb: pb || headerStyle.pb, color: color || headerStyle.color, align: align || headerStyle.align, fontSize: fontSize || headerStyle.fontSize, size: size, lineheight: lineheight || headerStyle.lineheight, fontFamily: fontFamily, fontWeight: fontWeight }, children));
};
var sanitizeHeaderSize = function (headerProps, defaultSize) {
    if (!headerProps.size || !headerStyles[headerProps.size]) {
        headerProps.size = defaultSize;
    }
};
export var H1 = function (props) {
    var children = props.children, headerProps = __rest(props, ["children"]);
    sanitizeHeaderSize(headerProps, HeadingSize.H1);
    return getHeader(headerProps, children, "h1");
};
export var H1Large = function (props) {
    var children = props.children, headerProps = __rest(props, ["children"]);
    sanitizeHeaderSize(headerProps, HeadingSize.H1Large);
    return getHeader(headerProps, children, "h1");
};
export var H2 = function (props) {
    var children = props.children, headerProps = __rest(props, ["children"]);
    sanitizeHeaderSize(headerProps, HeadingSize.H2);
    return getHeader(headerProps, children, "h2");
};
export var H3 = function (props) {
    var children = props.children, headerProps = __rest(props, ["children"]);
    sanitizeHeaderSize(headerProps, HeadingSize.H3);
    return getHeader(headerProps, children, "h3");
};
export var H4 = function (props) {
    var children = props.children, headerProps = __rest(props, ["children"]);
    sanitizeHeaderSize(headerProps, HeadingSize.H4);
    return getHeader(headerProps, children, "h4");
};
export var H5 = function (props) {
    var children = props.children, headerProps = __rest(props, ["children"]);
    sanitizeHeaderSize(headerProps, HeadingSize.H5);
    return getHeader(headerProps, children, "h5");
};
var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["all"] = 0] = "all";
    Breakpoints[Breakpoints["tablet"] = 1] = "tablet";
    Breakpoints[Breakpoints["mobile"] = 2] = "mobile";
})(Breakpoints || (Breakpoints = {}));
var getStyle = function (property, value, breakpoint, defaultValue) {
    if (breakpoint === void 0) { breakpoint = Breakpoints.all; }
    if (value) {
        if (typeof value === "string") {
            if (value !== "") {
                return property + ": " + value + ";";
            }
            if (defaultValue) {
                return property + ": " + defaultValue + ";";
            }
            return "";
        }
        if (!value.length) {
            if (defaultValue) {
                return property + ": " + defaultValue + ";";
            }
            return "";
        }
        var val = (breakpoint > 1 && value[2]) || (breakpoint > 0 && value[1]) || value[0];
        if (val) {
            return property + ": " + val + ";";
        }
    }
    if (defaultValue) {
        return property + ": " + defaultValue + ";";
    }
    return "";
};
export default H1;
var templateObject_1;
